export const MOBILE_BREAKPOINT = 1280

// Emplacement depuis lequel les devis revendeurs sont préparés (Atelier Paris).
// Doit rester aligné avec la location sur laquelle le backend pose les holds
// de devis (Component::performComputeHolds).
export const RETAILER_ESTIMATES_LOCATION_ID = 6

// Domaine dédié aux pièces servies aux clients (facture, feuille douanière,
// étiquette, rapport SAV). Le défaut vise la production : rien à configurer
// hors du poste de dev, où VITE_DOCUMENTS_URL pointe le .test.
export const DOCUMENTS_URL =
    import.meta.env.VITE_DOCUMENTS_URL ?? 'https://documents.baltic-watches.com'

// Base URL of the backoffice API: same origin as the SPA, so the browser sends
// no CORS preflight. /api mirrors api.baltic-watches.com path for path — the
// Pages Function in functions/api/[[path]].js does it in production, Vite's
// dev proxy locally (vite.config.js, target VITE_API_URL) — and /backoffice
// stays the prefix that carries the audience.
//
// No environment variable is read here on purpose: .env is not versioned, and
// a build that forgot one used to put "undefined" into every URL — the failure
// that took the retailer SPA down on 2026-08-21.
export const BACKOFFICE_API_URL = '/api/backoffice'
